<template>
    <Breadcrumbs :list="breadcrumpsList"/>
    <div class="main-card mb-3 card">
        <div class="card-body">
            <ml-form
                    :dataForm="formData"
                    :struct="formStruct"
                    @submittedForm="sendValue"
                    @canceledForm="cancelForm"
                    @changeValue="changeValue"
            />


        </div>
    </div>
</template>



<script>
    import Breadcrumbs from '@miro-labs/vue3-architect-layout/layout/base/Breadcrumbs.vue'
    import Form from '../../../form/ml/form/From.vue'
    import {updateValue} from '../../../form/ml/form/class/InputsManager'

    export default {

        components: {
            Breadcrumbs,
            'ml-form': Form
        },


        data() {

            const breadcrumpsList = [
                {label: "Strona główna", routerName: 'mainPage', params: {}, query: {}},
                {label: "CMS", routerName: 'cmsGalleryFolderList', params: {}, query: {}},
                {label: "Kadra", routerName: 'personList', params: {}, query: {}},
                {label: "Edycja"}
            ];

            return {
                roles: [],
                formData: {
                    name: '',
                    description: '',
                    active: false
                },
                formStruct: {fields: []},
                breadcrumpsList

            }
        },


        methods: {
            async changeValue(data) {
                updateValue(this.formData, data);
            },

            async sendValue(data) {
                data.resource = data.resource.length > 0 ? data.resource[0] : null;
                await this.$store.dispatch('person/savePerson', data);
                this.$router.replace({name: 'personList', params: {id: this.$route.params.userId}});

            },
            cancelForm() {
                this.$router.replace({name: 'personList', params: {id: this.$route.params.userId}});
            }

        },

        async beforeMount() {
            let url = process.env.VUE_APP_API_HOST + '/api/cms/resources';
            let token = await this.$store.dispatch("api/getTicket");
            if (this.$route.params.id) {
                this.formData = await this.$store.dispatch('person/findPerson', this.$route.params.id);
                this.formData.resource = this.formData.resource ? [this.formData.resource] : [];
            } else {
                this.formData = {
                    name: '',
                    job: '',
                    description: '',
                    priority: null,
                    resource: []
                }
            }

            this.formStruct = {
                rebuild: true,
                fields: [
                    {type: 'TEXT', name: 'name', label: 'Imię i nazwisko', placeholder: 'Wpisz imię i nazwisko',
                        tooltip: 'Wpisz imię i nazwisko', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane',
                        maxLength: 200, maxLengthMessage: 'Pole może mieć maksymalnie 200 znaków'},
                    {type: 'TEXT', name: 'job', label: 'Stanowisko', placeholder: 'Wpisz stanowisko',
                        tooltip: 'Wpisz stanowisko', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane',
                        maxLength: 200, maxLengthMessage: 'Pole może mieć maksymalnie 200 znaków'},
                    {type: 'NUMBER', name: 'priority', label: 'Kolejnosć', placeholder: 'Ustaw nr kolejność',
                        tooltip: 'Wpisz kolejność', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane', locale: 'pl-PL', maxFractionDigits: 0},
                    {type: 'TEXTAREA', name: 'description', label: 'Opis skrócony', placeholder: 'Wpisz opis',
                        tooltip: 'Wpisz opis', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane',
                        maxLength: 800, maxLengthMessage: 'Pole może mieć maksymalnie 800 znaków'},
                    {type: 'FILE_UPLOAD', name: 'resource', label: 'Zdjęcie', token: token,
                        url: url, multiple: false,
                        info: '', required: false, fileLimit: 1},
                    {type: 'EDITOR', name: 'content', label: 'Treść',
                        info: '', required: true},

                ],
                cancelValue: 'Anuluj',
                submitValue: 'Zapisz'
            };

        }
    }

</script>